var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2069 12.5861L19.4144 9.79297C19.3215 9.70009 19.2113 9.62641 19.0899 9.57614C18.9686 9.52587 18.8385 9.5 18.7072 9.5C18.5759 9.5 18.4458 9.52587 18.3245 9.57614C18.2031 9.62641 18.0929 9.70009 18 9.79297L10.2931 17.5005C10.1999 17.593 10.1259 17.7031 10.0756 17.8245C10.0253 17.9458 9.99959 18.076 10 18.2073V21.0005C10 21.2657 10.1054 21.52 10.2929 21.7076C10.4804 21.8951 10.7348 22.0005 11 22.0005H13.7931C13.9245 22.0009 14.0546 21.9752 14.176 21.9249C14.2973 21.8746 14.4075 21.8006 14.5 21.7073L22.2069 14.0005C22.2998 13.9076 22.3734 13.7974 22.4237 13.676C22.474 13.5547 22.4999 13.4246 22.4999 13.2933C22.4999 13.1619 22.474 13.0319 22.4237 12.9105C22.3734 12.7892 22.2998 12.679 22.2069 12.5861ZM13.7931 21.0005H11V18.2073L16.5 12.7073L19.2931 15.5005L13.7931 21.0005ZM20 14.793L17.2069 12.0005L18.7069 10.5005L21.5 13.293L20 14.793Z",
    fill: "#748181"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#ECEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bad0f64cc1c539533989f1665423ae6a.svg";
export { ForwardRef as ReactComponent };